<template>
  <div class="modal-overlay" v-show="showModal === true">
    <div class="modals">
      <div v-if="isSignOut == false" class="text-center">
        <div v-show="type === true">
          <img src="/assets/images/icon-success.svg" width="100" class="check"/>
        </div>
        <div v-show="type === false">
          <img src="/assets/images/errorImg.png" width="100" class="check"/>
        </div>
        <h6 class="my-3">{{ message }}</h6>
        <button @click="closeModal" class="btn primaryBtn mt-1">Close</button>
      </div>
      <div v-if="isSignOut">
          <div class="pb-3 mb-4 text-center fw-bold">Are you sure you want to sign out?</div>
          <div class="mb-2"><button @click="logOutCloseModal" class="btn btn-danger w-100">Sign me out</button></div>
          <div><button @click="closeModal" class="btn btn-light w-100 border">Cancel</button></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'MyModal',
  methods: {
    ...mapActions({
      logout: 'user/logout',
      logoutAdmin: 'admin/logout',
      logoutScout: 'scout/logout',
      closeModalNow: 'general/hideModal'
    }),
    closeModal () {
      this.closeModalNow()
    },
    logOutCloseModal () {
      this.closeModalNow()
      if (this.$store.state.user.currentUser !== null) {
        this.logout()
      }
      if (this.$store.state.admin.currentUser !== null) {
        this.logoutAdmin()
      }
      if (this.$store.state.scout.currentUser !== null) {
        this.logoutScout()
      }
    }
  },
  computed: {
    showModal () {
      return this.$store.state.general.showModal
    },
    type () {
      return this.$store.state.general.info.type
    },
    message () {
      return this.$store.state.general.info.message
    },
    isSignOut () {
      return this.$store.state.general.isSignOut
    }
  }
}
</script>
<style scoped>

.modal-overlay {
  position: absolute;
  top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    background-color: #4e4e4eda;
    z-index: 9;
}

.modals {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: white;
    width: 400px;
    height: 300px;
    margin-top: 5%;
    max-width: 90%;
    border-radius: 10px;
}
</style>
